import { GetVariableValue } from 'hooks'
import { BrandingColorStyles, BrandingThemeType, Resource, Screen } from 'utils'
import { setColors } from './setColors'

export const createScreen = async (
  id: string,
  screenConfig: Screen,
  parent: HTMLDivElement | SVGForeignObjectElement,
  colorStyles: BrandingColorStyles,
  theme: BrandingThemeType,
  resources: Resource[],
  getVariableValue: GetVariableValue,
  onClickComponent?: () => void
) => {
  const fromVB = !!onClickComponent
  const { backgroundColor, backgroundGradient, backgroundPattern } = screenConfig

  const screen = document.createElement('div')
  parent.appendChild(screen)

  screen.id = id
  screen.style.width = '100%'
  screen.style.height = '100%'
  screen.style.display = 'flex'
  screen.style.flexDirection = 'column'

  if (fromVB) {
    screen.onmousedown = () => onClickComponent()
  }

  await setColors(
    screen,
    colorStyles,
    theme,
    resources,
    getVariableValue,
    backgroundColor,
    backgroundGradient,
    backgroundPattern
  )

  return screen
}

export const createAlertScreen = (
  screen: HTMLElement,
  parent: HTMLDivElement | SVGForeignObjectElement,
  backImage: string
) => {
  screen.style.width = '270px'
  screen.style.height = 'auto'
  screen.style.padding = '16px 16px 62px'
  screen.style.borderRadius = '14px'
  screen.style.position = 'absolute'
  screen.style.top = '50%'
  screen.style.left = '50%'
  screen.style.transform = 'translate(-50%, -50%)'
  screen.style.textAlign = 'center'
  screen.style.gap = '10px'
  screen.style.background = '#F2F2F2'

  const actions = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
  actions.style.pointerEvents = 'none'
  actions.setAttribute('viewBox', '0 0 270 46')
  actions.setAttribute('width', '100%')
  actions.setAttribute('height', '46px')
  actions.style.position = 'absolute'
  actions.style.left = '0'
  actions.style.bottom = '0'
  actions.innerHTML = `
    <rect width="270" height="0.5" fill="#3C3C43" fill-opacity="0.36"/>
    <path d="M25.063 29H29.1718C32.7329 29 34.8247 26.7837 34.8247 23.0151V22.9985C34.8247 19.2383 32.7246 17.022 29.1718 17.022H25.063V29ZM26.5571 27.6553V18.3667H29.0722C31.7285 18.3667 33.2973 20.0933 33.2973 23.0151V23.0317C33.2973 25.9453 31.7451 27.6553 29.0722 27.6553H26.5571ZM40.5011 29.1577C43.0495 29.1577 44.6266 27.3979 44.6266 24.5342V24.5176C44.6266 21.6455 43.0495 19.894 40.5011 19.894C37.9528 19.894 36.3757 21.6455 36.3757 24.5176V24.5342C36.3757 27.3979 37.9528 29.1577 40.5011 29.1577ZM40.5011 27.8794C38.8078 27.8794 37.8532 26.6426 37.8532 24.5342V24.5176C37.8532 22.4009 38.8078 21.1724 40.5011 21.1724C42.1945 21.1724 43.1491 22.4009 43.1491 24.5176V24.5342C43.1491 26.6426 42.1945 27.8794 40.5011 27.8794ZM46.4598 29H47.9042V23.7041C47.9042 22.1353 48.809 21.1724 50.2367 21.1724C51.6644 21.1724 52.3285 21.9443 52.3285 23.5547V29H53.7728V23.2061C53.7728 21.0811 52.6522 19.894 50.6434 19.894C49.3236 19.894 48.4852 20.4502 48.037 21.3965H47.9042V20.0518H46.4598V29ZM56.5606 21.7451H57.7559L57.9303 17.022H56.3863L56.5606 21.7451ZM63.7976 29.0664C64.0799 29.0664 64.3538 29.0332 64.636 28.9834V27.7549C64.3704 27.7798 64.2293 27.7881 63.972 27.7881C63.0423 27.7881 62.677 27.3647 62.677 26.3105V21.2471H64.636V20.0518H62.677V17.7358H61.1829V20.0518H59.7718V21.2471H61.1829V26.6758C61.1829 28.3857 61.9549 29.0664 63.7976 29.0664ZM69.9875 29H71.5564L72.76 25.5718H77.5246L78.7282 29H80.2971L75.8811 17.022H74.4035L69.9875 29ZM75.0759 18.9561H75.2087L77.0847 24.3018H73.1999L75.0759 18.9561ZM81.8896 29H83.3339V16.499H81.8896V29ZM85.7814 29H87.2257V16.499H85.7814V29ZM93.2674 29.1577C95.8158 29.1577 97.3929 27.3979 97.3929 24.5342V24.5176C97.3929 21.6455 95.8158 19.894 93.2674 19.894C90.7191 19.894 89.1419 21.6455 89.1419 24.5176V24.5342C89.1419 27.3979 90.7191 29.1577 93.2674 29.1577ZM93.2674 27.8794C91.5741 27.8794 90.6195 26.6426 90.6195 24.5342V24.5176C90.6195 22.4009 91.5741 21.1724 93.2674 21.1724C94.9608 21.1724 95.9154 22.4009 95.9154 24.5176V24.5342C95.9154 26.6426 94.9608 27.8794 93.2674 27.8794ZM100.621 29H102.065L104.057 22.0771H104.19L106.19 29H107.643L110.15 20.0518H108.714L106.954 27.207H106.821L104.821 20.0518H103.451L101.451 27.207H101.318L99.5581 20.0518H98.1138L100.621 29Z" fill="#007AFF"/>
    <rect x="134.75" y="0.5" width="0.5" height="45" fill="#3C3C43" fill-opacity="0.36"/>
    <path d="M182.798 29H184.367L185.57 25.5718H190.335L191.539 29H193.108L188.691 17.022H187.214L182.798 29ZM187.886 18.9561H188.019L189.895 24.3018H186.01L187.886 18.9561ZM194.7 29H196.144V16.499H194.7V29ZM198.592 29H200.036V16.499H198.592V29ZM206.078 29.1577C208.626 29.1577 210.203 27.3979 210.203 24.5342V24.5176C210.203 21.6455 208.626 19.894 206.078 19.894C203.53 19.894 201.952 21.6455 201.952 24.5176V24.5342C201.952 27.3979 203.53 29.1577 206.078 29.1577ZM206.078 27.8794C204.384 27.8794 203.43 26.6426 203.43 24.5342V24.5176C203.43 22.4009 204.384 21.1724 206.078 21.1724C207.771 21.1724 208.726 22.4009 208.726 24.5176V24.5342C208.726 26.6426 207.771 27.8794 206.078 27.8794ZM213.431 29H214.875L216.868 22.0771H217L219.001 29H220.454L222.96 20.0518H221.524L219.765 27.207H219.632L217.631 20.0518H216.262L214.261 27.207H214.128L212.369 20.0518H210.924L213.431 29Z" fill="#007AFF"/>
  `
  screen.appendChild(actions)

  const background = document.createElement('div')
  background.style.pointerEvents = 'none'
  background.style.width = '100%'
  background.style.height = '100%'
  background.style.backgroundImage = `url(${backImage})`
  background.style.backgroundSize = 'cover'
  background.style.position = 'absolute'
  background.style.top = '0'
  background.style.left = '0'
  parent.insertBefore(background, screen)

  const shadow = document.createElement('div')
  shadow.style.pointerEvents = 'none'
  shadow.style.width = '100%'
  shadow.style.height = '100%'
  shadow.style.background = '#000000d9'
  shadow.style.position = 'absolute'
  shadow.style.top = '0'
  shadow.style.left = '0'
  parent.insertBefore(shadow, screen)
}
